// #region imports

// --- Angular
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';

// --- HS Code
import { Utils } from '../';

// #endregion

@Component({
  selector: 'hs-online-status',
  templateUrl: './online-status.component.html',
  styleUrls: ['./online-status.component.scss'],
  animations: [
    trigger('onlineStatusAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(-50%)', opacity: 0 }),
        animate('200ms', style({ transform: 'translateY(0%)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0%)', opacity: 1 }),
        animate('200ms', style({ transform: 'translateY(-50%)', opacity: 0 }))
      ]),
    ])
  ]
})
export class OnlineStatusComponent {
  @Input() networkStatusMessage: string = '';
  @Input() networkStatus: string = '';
  @Input() callToActionLabel: string = '';

  @Output() callToAction = new EventEmitter();
  @Output() closeAlert = new EventEmitter();

  alertShow = true;
  alertTimerInstance: ReturnType<typeof setTimeout> | null;

  constructor() {
    this.alertTimerInstance = null;
  }

  ngOnInit() {
    this.setup(this.networkStatus);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['networkStatus'] && changes['networkStatus'].currentValue) {
      this.setup(changes['networkStatus'].currentValue);
    }
  }

  setup(status: string) {
    if (!status) {
      return;
    }

    if (!Utils.isNull(this.alertTimerInstance)) {
      clearTimeout(this.alertTimerInstance as ReturnType<typeof setTimeout>);
    }
    switch (status) {
      case 'online':
        this.alertShow = true;
        this.alertTimerInstance = setTimeout(() => {
          this.alertShow = false;
        }, 3000);
        break;
      default:
        this.alertShow = true;
    }
  }

  callToActionClick(): void {
    this.callToAction.emit();
  }

  closeClick(): void {
    this.alertShow = false;
    this.closeAlert.emit();
  }
}
